import { jFileLittle, Network } from 'jamespot-user-api';
import React from 'react';
import { JRCInputFileAdvancedRaw } from '../../Form/Input/JRCInputFileAdvanced/JRCInputFileAdvancedRaw';

export const EditorUploader = ({
    token,
    uniqid,
    label,
    accept,
    multiple,
    name = 'editorFiles',
    network,
    onUploadStart,
    onUploadSuccess,
    onUploadSucessEnd,
}: {
    token: string;
    uniqid: string;
    label: string;
    accept: string;
    multiple: boolean;
    name?: 'editorFiles' | 'attachment';
    network?: Pick<Network, 'token' | 'postFile' | 'getUrl'>;
    onUploadStart: (count?: number) => void;
    onUploadSuccess: (response: jFileLittle) => void;
    onUploadSucessEnd?: () => void;
}) => {
    const uploadRef = React.useRef<HTMLInputElement>(null);
    const [fileUploadStep, setFileUploadStep] = React.useState<number>(0);
    const [filesCount, setFilesCount] = React.useState<number | undefined>(undefined);

    React.useEffect(() => {
        if (fileUploadStep === filesCount && onUploadSucessEnd) {
            onUploadSucessEnd();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fileUploadStep]);

    return (
        <JRCInputFileAdvancedRaw
            ref={uploadRef}
            id={`file-${uniqid}`}
            name={name}
            content={label}
            accept={accept as any}
            multiple={multiple}
            token={token}
            network={network}
            onUploadStart={(count) => {
                onUploadStart();
                if (count && filesCount === undefined) {
                    setFilesCount(count);
                }
            }}
            onUploadSuccess={(fileResponse) => {
                setFileUploadStep((prevStep) => prevStep + 1);
                onUploadSuccess(fileResponse);
            }}
        />
    );
};
